export default () => ({
    dummyData: 'dummyData',
});
